import { Skeleton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { ItemsTable } from 'src/components/pages/purchases/logic/ItemsTable'
import { CardCommon } from 'src/components/uiElements'
import { getJWT } from 'src/helper/localStore/getJWT'

export const ItemsToPayModal = ({id}) => {
    const translate = useTranslate()
    const [itemsToSelect, setItemsToSelect] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const notify = useNotify()
    const [record, setRecord] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const getPaymentOrder = async () =>{
        try{
            setIsLoading(true)
            const data = await fetch(
                `${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order/${id}`,
                { 
                    headers: { 'authentication-token': getJWT() },
                    method: "GET",
                })
            const response = await data.json()
            setIsLoading(false)
            if(response){
                const initialitems = response?.supplier_payment_order_item_relation?.map(item=>{return {...item.item_supplier_relation, supplier_name:response?.supplier_relation.name, amount_pending:item.item_supplier_relation?.amount_pending, amount:item.amount}})
                setSelectedItems(initialitems)
                setItemsToSelect(initialitems)
                setRecord(response)
            }
        } catch {
            notify('ra.message.error_retrieve',{type:'error'})
        }
    }

    useEffect(()=>{
        getPaymentOrder()
        
      },[id])
  return (
    <CardCommon title={translate('ra.title.list_item_to_pay')} >
        {isLoading ? 
            <Skeleton />:
            <ItemsTable title={translate('ra.title.item_selected')} isShow enableFilters={false} supplierId={record?.supplier_id} selectedItems={itemsToSelect} setSelectedItems={setItemsToSelect} editData={selectedItems} />
        }
        
    </CardCommon>
  )
}
